<dx-date-box
  [value]="value"
  (onValueChanged)="onDateSelected($event)"
  openOnFieldClick="true"
  [displayFormat]="getDisplayFormat()">
  <dxo-calendar-options
    [zoomLevel]="getSelectedLevel()"
    [maxZoomLevel]="getSelectedLevel()">
  </dxo-calendar-options>
</dx-date-box>
